<template>
  <section class="statistics-box">
    <section class="statistics-total">
      <div class="total-item">
        <div class="total-item_title">支付金额</div>
        <div class="total-item_num">{{ todayData.free }}</div>
        <div class="total-item_thirty">近30天 {{ totalData.free }}</div>
      </div>
      <div class="total-item">
        <div class="total-item_title">支付笔数</div>
        <div class="total-item_num">{{ todayData.pay_num }}</div>
        <div class="total-item_thirty">近30天 {{ totalData.pay_num }}</div>
      </div>
      <div class="total-item">
        <div class="total-item_title">订单数</div>
        <div class="total-item_num">{{ todayData.num }}</div>
        <div class="total-item_thirty">近30天 {{ totalData.num }}</div>
      </div>
    </section>
    <section class="statistics-chart">
      <div class="chart-top">
        <div class="chart-title">{{todayData.date}}</div>
        <div class="chart-tr">
          <div @click.stop="initCart(item.value)" v-for="item in lineTypeList" :key="item.value" class="chart-btn" :class="[lineType === item.value ? 'chart-btn_active' : '']">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div id="line_chart"></div>
    </section>
    <section class="statistics-thirtylist">
      <div class="thirtylist-title">
        <span class="thirty_date">日期</span>
        <span class="thirty_num">订单数</span>
        <span class="thirty_paynum">支付笔数</span>
        <span class="thirty_free">总金额</span>
      </div>
      <div class="thirtylist">
        <div v-for="(item, index) in list" :key="item.date">
          <div class="thirtylist-item" @click="getStatisticsDayData(item.date, index)">
            <span class="thirty_date thirty_date_bold">{{item.date}}</span>
            <span class="thirty_num">{{item.num}}</span>
            <span class="thirty_paynum">{{item.pay_num}}</span>
            <span class="thirty_free">{{item.free}}</span>
          </div>
          <div class="thirtylist-content" v-if="item.expand">
            <div v-for="(v, k) in item.content" :key="v.date">
              <div class="thirtylist-item thirty_font13" @click="expandContentHandle(k)">
                <span class="thirty_date">{{v.name}}</span>
                <template  v-if="!v.expand">
                  <span class="thirty_num">{{v.num}}</span>
                  <span class="thirty_paynum">{{v.pay_num}}</span>
                  <span class="thirty_free">{{v.free}}</span>
                </template>
              </div>
              <div class="thirtylist-content thirtylist-content_flex" v-if="v.expand">
                <span class="thirty_num">订单数：{{v.num}}</span>
                <span class="thirty_paynum">支付笔数：{{v.pay_num}}</span>
                <span class="thirty_free">总金额：{{v.free}}</span>
                <span class="thirty_free">微信：{{v.wx.free}}</span>
                <span class="thirty_free">支付宝：{{v.ali.free}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <p class="statistics-tips">仅显示近30天数据</p>
  </section>
</template>

<script >
import * as echarts from "echarts";
import {getStatisticsDay, getThirtyDays, checkTime} from "@/api/iwin11Statistics";

export default {
  name: 'Statistics',
  data() {
    return {
      lineTypeList: [
        {title: '总金额', value: 'free'},
        {title: '订单数', value: 'num'},
        {title: '支付笔数', value: 'pay_num'}
      ],
      list: [],
      totalData: {},
      todayData: {},
      expandIndex: null, // 当前展开的日期数据下标
      expandContentIndex: null, // 当前展开的系统数据下标
      lineCart: null, // 折线图
      numCart: null, // 折线图
      payNumCart: null, // 折线图
      lineType: 'free', // free-总金额 num-订单数 pay_num-支付笔数
    }
  },
  async created() {
    const {data} = await checkTime(this.$route.query)
    if (data.res) {
      getThirtyDays().then(res => {
        this.totalData = res.data.total
        this.todayData = res.data.today
        this.list = res.data.list.map(item => {
          return {
            ...item,
            expand: false,
            content: []
          }
        })
        this.lineCart = echarts.init(document.getElementById("line_chart"));
        this.initCart('free');
      })
    } else {
      this.$router.push('404')
    }
  },
  mounted() {
    setTimeout(() => {
      document.title = "iWin11交易统计";
    }, 100)
  },
  methods: {
    /**
     * 展开系统数据
     * @param index
     */
    expandContentHandle(index) {
      if (this.expandContentIndex === index) return this.list[this.expandIndex].content[index].expand = !this.list[this.expandIndex].content[index].expand
      if (this.expandContentIndex !== null) this.list[this.expandIndex].content[this.expandContentIndex].expand = false
      this.expandContentIndex = index
      this.list[this.expandIndex].content[index].expand = true
    },
    /**
     * 展开日期数据
     * @param date
     * @param index
     */
    getStatisticsDayData(date, index) {
      if (this.expandIndex === index)  {
        this.list[index].expand = !this.list[index].expand
        this.list[index].content = this.list[index].content.map(item => {
          return {
            ...item,
            expand: false
          }
        })
        return
      }
      if (this.expandIndex !== null) this.list[this.expandIndex].expand = false
      if (this.list[index].content.length) {
        this.expandIndex = index
        this.list[index].expand = true
      } else {
        getStatisticsDay({date}).then(res => {
          this.list[index].content = res.data.map(item => {
            return {
              ...item,
              expand: false
            }
          })
          this.expandIndex = index
          this.list[index].expand = true
        })
      }
    },
    initCart(type) {
      this.lineType = type
      const data = this.list.map(item => {
        return item.date
      })
      let seriesData = []
      if (type === 'free') {
        seriesData = this.list.map(item => {
          return {name: item.date, value: Number(item.free)}
        })
      } else if (type === 'num') {
        seriesData = this.list.map(item => {
          return {name: item.date, value: Number(item.num)}
        })
      } else {
        seriesData = this.list.map(item => {
          return {name: item.date, value: Number(item.pay_num)}
        })
      }
      const option = {
        xAxis: {
          show: true,
          data: data,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            length: 20 // 竖线的长度
          }
        },
        yAxis: {
          splitLine: {
            show: true
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}"
          }
        },
        series: [
          {
            smooth: true,
            type: "line",
            data: seriesData,
            color: '#5691F7',
          }
        ]
      }
      this.lineCart.setOption(option);
    },
  }
}
</script>

<style scoped>
.statistics-box {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 30px 10px;
  box-sizing: border-box;
}

.statistics-total {
  width: 100%;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #5691F7;
  border-radius: 12px;
  color: #000;
  display: flex;
}

.total-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
}

.total-item_title {
  color: #fff;
  opacity: 0.5;
  font-size: 14px;
}

.total-item_num {
  font-weight: bold;
  font-size: 26px;
  color: #fff;
}

.total-item_thirty {
  color: #fff;
  opacity: 0.5;
  font-size: 14px;
}

.statistics-chart {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  position: relative;
}

.chart-top {
  width: 90%;
  position: absolute;
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center;
  top: 0;
  z-index: 9999;
}

.chart-title {
  font-weight: 800;
  font-size: 16px;
  color: #000000;
}

.chart-tr {
  display: flex;
  gap: 10px;
}

.chart-btn {
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 15px;
  background: #F8F8FA;
  color: #CFCFCF;
}

.chart-btn_active {
  background: #5691F7;
  color: #FFFFFF;
}

#line_chart{
  width: 105%;
  height: 300px;
}

.statistics-thirtylist {
  width: 100%;
  padding: 20px 0 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  color: #525252;
  font-size: 14px;
}

.thirtylist-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 10px;
}

.thirtylist-item {
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
}

.thirty_font13 {
  font-size: 13px;
}

.thirty_date {
  flex: 1;
}

.thirty_date_bold {
  font-weight: bold;
}

.thirty_num {
  flex: 0 0 70px;
  text-align: center;
}

.thirty_paynum {
  flex: 0 0 70px;
  text-align: center;
}

.thirty_free {
  flex: 0 0 70px;
  text-align: center;
}

.thirtylist-content {
  padding: 10px 0 ;
  background-color: #ececec;
  border-radius: 12px;
}

.thirtylist-content_flex {
  padding-right: 20px;
  gap: 10px;
  display: grid; /* 启用网格布局 */
  grid-template-columns: repeat(3, 1fr); /* 创建3列，每列宽度相等 */
}

.statistics-tips {
  color: #666;
  text-align: center;
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/Statistics.vue